export default __webpack_public_path__ + "static/media/it930-a033-4.067029d3.jpg";